import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('carSaleStore', Object.keys(state)),
	...mapGetters('carSaleStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('carSaleStore', Object.keys(actions)),
	...mapMutations('carSaleStore', Object.keys(mutations))
};
